function ProductCardSkeleton() {
  return (
    <div className="card overflow-hidden animate-pulse">
      {/* Image skeleton */}
      <div className="aspect-square bg-gray-200" />

      {/* Content skeleton */}
      <div className="p-4 space-y-3">
        {/* Category badge */}
        <div className="h-5 w-20 bg-gray-200 rounded-full" />

        {/* Brand */}
        <div className="h-3 w-16 bg-gray-200 rounded" />

        {/* Product name */}
        <div className="space-y-2">
          <div className="h-4 bg-gray-200 rounded" />
          <div className="h-4 w-3/4 bg-gray-200 rounded" />
        </div>

        {/* Price */}
        <div className="h-6 w-24 bg-gray-200 rounded" />

        {/* Vendor count */}
        <div className="h-4 w-28 bg-gray-200 rounded" />

        {/* CTA */}
        <div className="h-4 w-32 bg-gray-200 rounded" />
      </div>
    </div>
  );
}

export default ProductCardSkeleton;
